module.exports = __webpack_public_path__ + "media/images/fav/academy_favicon-8f0a10b83a24b8d744de0086cc3009e8.ico";